import React from "react";
import { Col, Row } from "reactstrap";

const About = () => {
  return (
    <Row className="justify-content-around">
      <Col sm="10" md="10" lg="10" className="about--header">
        <h3>About Us</h3>
        <p>
          As the founders of{" "}
          <a href="https://codeyourfuture.io/">CodeYourFuture</a> , a full-stack
          JS coding program for refugees (JavaScript/React/Node), we have been
          training refugees to become developers since 2016. Our graduates have
          joined the tech workforce of large media companies, such as the
          Financial Times and tech startups (Sensible Object and We Got Pop).
        </p>
        <p>
          We have experience working in global corporations, including Samsung
          Electronics, as well as major startups, such as Secret Escapes. In our
          previous corporate existence we have helped business develop services
          that scale to deal with millions of daily visitors. Our aim now is to
          make tech industry become more ethical through diversity and
          inclusion. This includes cooperating with various international
          organisations, such as the Institute of Migration.
        </p>
      </Col>
    </Row>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/pages/Home/About.js